import React from "react"
import PropTypes from "prop-types"
import EditSampleSmallCard from "./EditSampleSmallCard"
import { styled } from "@mui/material/styles"
import { observer } from "mobx-react"
import { TransitionGroup } from "react-transition-group"
import {
  Zoom
} from "@mui/material"

const EditSampleSmallCardsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
`

@observer
export default class EditSampleSmallCards extends React.Component {

  render() {
    const { show_sample_select, samples, categories } = this.props
    const additional_props = { show_sample_select: show_sample_select }

    return (
      <EditSampleSmallCardsContainer>
        <TransitionGroup component={null}>
          {samples.map((sample) => {
            return (
              <Zoom key={sample.slug}>
                <div>
                  <EditSampleSmallCard sample={sample} categories={categories} />
                </div>
              </Zoom>
            )
          })}
        </TransitionGroup>
      </EditSampleSmallCardsContainer>
    )
  }

}
